import "./style.css";

const FilledCard = ({ card, onClick }) => {
	return (
		<div className="filledCard" onClick={onClick}>
			<div className="filledCard top" style={{ backgroundColor: card.backgroundColor }}>
				<img src={card.icon} alt="icon" />
				{card.title}
			</div>
			<div className="filledCard content">{card.content}</div>
		</div>
	)
}

export default FilledCard;